import React, { useState } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { useAppSelector } from '../../../../state/state';
import { selectEffectiveUID, selectOriginalUserProfile } from '../../../../state/UserStatesV2/userSliceV2';
import { selectActiveRole } from '../../../../state/UserStatesV2/userSliceV2';
import PollsQuizzes from './Components/PollsQuizzes';
import RecordedSessions from './Components/RecordedSessions';

const MeetPlusAdvanced: React.FC = () => {
    const { subscriptionid } = useParams<{ subscriptionid: string }>();
    const navigate = useNavigate();
    const location = useLocation();
    
    // Get initial tab from URL query parameter
    const urlParams = new URLSearchParams(location.search);
    const initialTab = urlParams.get('tab') === 'recorded' ? 'recorded' : 'polls';
    const [activeTab, setActiveTab] = useState<'polls' | 'recorded'>(initialTab);
    
    const providerId = useAppSelector(selectEffectiveUID);
    const userProfile = useAppSelector(selectOriginalUserProfile);
    const activeRole = useAppSelector(selectActiveRole);

    // Get subscription name from route state or fallback
    const subscriptionName = (location.state as any)?.subscriptionName || 'Subscription';

    return (
        <div className="min-h-screen bg-gray-50">
            {/* Header */}
            <div className="bg-gradient-to-r from-purple-600 to-blue-600 text-white">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
                    <div className="flex items-center justify-between">
                        <div className="flex items-center gap-4">
                            <button
                                onClick={() => navigate(-1)}
                                className="p-2 hover:bg-white/10 rounded-lg transition-colors"
                            >
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <path d="M19 12H5M12 19l-7-7 7-7"/>
                                </svg>
                            </button>
                            <div>
                                <h1 className="text-2xl font-bold">Meet+ Advanced Management</h1>
                                <p className="text-sm text-purple-100 mt-1">
                                    Manage polls, quizzes, and recording settings for your live sessions
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Navigation Tabs */}
            <div className="bg-white border-b border-gray-200 sticky top-0 z-10 shadow-sm">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <nav className="flex space-x-8">
                        <button
                            onClick={() => setActiveTab('polls')}
                            className={`py-4 px-1 border-b-2 font-medium text-sm transition-colors ${
                                activeTab === 'polls'
                                    ? 'border-purple-500 text-purple-600'
                                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                            }`}
                        >
                            <div className="flex items-center gap-2">
                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <rect x="3" y="3" width="18" height="18" rx="2"></rect>
                                    <path d="M9 9h6"></path>
                                    <path d="M9 15h6"></path>
                                </svg>
                                Polls & Quizzes
                            </div>
                        </button>

                        <button
                            onClick={() => setActiveTab('recorded')}
                            className={`py-4 px-1 border-b-2 font-medium text-sm transition-colors ${
                                activeTab === 'recorded'
                                    ? 'border-purple-500 text-purple-600'
                                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                            }`}
                        >
                            <div className="flex items-center gap-2">
                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <polygon points="23 7 16 12 23 17 23 7"></polygon>
                                    <rect x="1" y="5" width="15" height="14" rx="2" ry="2"></rect>
                                </svg>
                                Recorded Sessions
                            </div>
                        </button>
                    </nav>
                </div>
            </div>

            {/* Content */}
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                {activeTab === 'polls' && (
                    <PollsQuizzes
                        subscriptionId={subscriptionid || ''}
                        subscriptionName={subscriptionName}
                        userRole={activeRole?.role || 'teacher'}
                        isInMeeting={false}
                        participantName={userProfile?.display_name || 'Teacher'}
                        serviceProviderId={providerId}
                    />
                )}

                {activeTab === 'recorded' && (
                    <RecordedSessions
                        serviceProviderId={providerId}
                    />
                )}
            </div>
        </div>
    );
};

export default MeetPlusAdvanced;

